import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../services/api';

export const useExecutiveKPIs = (dateRange?: { start_date?: string; end_date?: string }) => {
  return useQuery({
    queryKey: ['executive-kpis', dateRange],
    queryFn: () => analyticsApi.getExecutiveKPIs(dateRange),
  });
};